import React from 'react';
import styled from 'styled-components';
import { getTranslatedString } from 'helpers/i18n';
import Spacer from 'components/ui/Spacer';
import Row from 'components/ui/Row';
import Col from 'components/ui/Col';
import Form from 'components/ui/Form';
import TextBox from 'components/ui/TextBox';
import { colors } from 'helpers/ColorHelper';

const FullWidthInput = styled(TextBox)`
  width: 100%;
`;

const StyledCount = styled.p`
  color: ${props => (props.maxCount ? `${colors.YUHU_RED}` : `${colors.CHAR_COUNT}`)};
  margin: 0px;
  margin-top: 5px;
  margin-right: 5px;
`;

const BatchNameInput = ({ values, errors, touched, setFieldValue }) => {
  const handleChange = event => {
    setFieldValue('name', event.target.value);
  };

  return (
    <Spacer mb={1}>
      <Row gutter={16}>
        <Col span={24}>
          <Form.Item
            label={`${getTranslatedString('landlordPortal.batches.batchName')}*`}
            validateStatus={touched.name && errors.name ? 'error' : null}
            help={touched.name && errors.name}
          >
            <FullWidthInput
              placeholder={getTranslatedString('landlordPortal.batches.batchName.placeholder')}
              size="large"
              name="name"
              value={values.name}
              onChange={handleChange}
            />
            {values.name && (
              <StyledCount maxCount={values.name.length > 50}>
                {`${values.name.length}/50 ${getTranslatedString(
                  'landlordPortal.batches.characters'
                )}`}{' '}
              </StyledCount>
            )}
          </Form.Item>
        </Col>
      </Row>
    </Spacer>
  );
};

export default BatchNameInput;
